import { requests } from './agent'
import { Bid } from '../models/Payments'

// interface BidResponse extends HttpResponse {
//   data: Auction
// }

const Bids = {
  send: (bid: Bid) => requests.post<any>('/bids', bid),
}

export default Bids
